<div class="regulator-context-box">
  <div class="regulator-context-items">
    @for (item of items; track item.label) {
      <div class="regulator-context-item">
        <span class="regulator-context-label">{{ item.label }}</span>
        <div class="regulator-context-content">
          @if (item.code) {
            <span class="badge bg-primary-subtle text-primary text-uppercase regulator-context-code">{{ item.code }}</span>
          }
          @if (item.value) {
            <span class="regulator-context-value">{{ item.value }}</span>
          }
          @if (!item.code && !item.value) {
            <span class="regulator-context-value">-</span>
          }
        </div>
      </div>
    }
  </div>
  <button type="button" class="btn btn-outline-secondary" (click)="back.emit()">
    <i class="bi bi-arrow-left me-1"></i>Back
  </button>
</div>
